import styled from 'styled-components/macro'

export const LabelTitle = styled.label`
  margin: 0 0 0.8rem;
  width: 100%;
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  color: ${(props) => props.theme.color.textThird};
`

export const Amount = styled.span`
  white-space: nowrap;
`

export const Box = styled.div`
  margin: 0;
  padding: 1.8rem;
  width: 100%;
  max-width: 56.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  border: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  border-radius: 0.8rem;
  overflow: hidden;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    padding: 2.2rem 1.8rem;
    display: grid;
    grid-template-columns: 1fr 18.4rem;
  `};
`

export const ApproveText = styled.p`
  margin: 0;

  width: 100%;
  display: inline-block;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  color: ${(props) => props.theme.color.text};
`

export const TableWrap = styled.div`
  margin: 0 0 3.2rem;
  width: 100%;
`

export const LoaderWrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  padding: 1.6rem;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: radial-gradient(rgba(0, 0, 0, 0) 0.2rem, ${(props) => props.theme.color.white} 0.2rem);
  background-size: 0.4rem 0.4rem;
  background-repeat: repeat;
  backdrop-filter: brightness(100%) blur(0.3rem);
  z-index: ${(props) => props.theme.zIndex.overlay};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    padding: 3.2rem;
  `};
`

export const LoaderContainer = styled.div`
  position: relative;
  padding: 2.4rem;
  width: 32rem;
  height: auto;
  max-height: calc(100vh - 3.2rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.2rem;
  background-color: ${(props) => props.theme.color.elementBg};
  border: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  border-radius: 0.8rem;
  transition: all 0.3s ease-in;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: ${(props) => props.theme.zIndex.modalContainer};
`

export const LoaderText = styled.p`
  margin: 0;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  text-align: center;
  color: ${(props) => props.theme.color.textThird};
`

export const MobilePecipient = styled.span`
  width: auto;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    display: none;
  `};
`

export const DesktopPecipient = styled.span`
  display: none;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    display: flex;
  `};
`
